import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import { ChannelService } from '@ninety/platform/services/services/channel.service';

import { selectCurrentUserId } from '../../app-entities/users/users-state.selectors';

import { RealTimeActions } from './real-time.actions';

@Injectable()
export class RealTimeEffects {
  actions$ = inject(Actions);
  channelService = inject(ChannelService);
  store = inject(Store);

  /** Send a message via Pub-nub. Do not use to broadcast messages over 32KB */
  sendMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RealTimeActions.sendMessage),
        concatLatestFrom(() => this.store.select(selectCurrentUserId)),
        tap(([{ channelId, message }, userId]) => this.channelService.publishMessage(userId, channelId, message))
      ),
    { dispatch: false }
  );
}
